import React from 'react';
import styled from 'styled-components';
import {
  ParsedTable,
  RenderedTable,
} from '@/features/ai-agents/chat/MarkdownTableVisualization/types';

interface SimpleTableViewProps {
  renderedTable: RenderedTable;
  table: ParsedTable;
}

export function SimpleTableView({
  renderedTable,
  table,
}: SimpleTableViewProps) {
  return (
    <SimpleTableWrapper>
      <SimpleTable>
        <SimpleThead>
          <tr>
            {table.headers.map((header, columnIndex) => (
              <SimpleTh key={columnIndex}>
                {renderedTable.headers[columnIndex] ?? header}
              </SimpleTh>
            ))}
          </tr>
        </SimpleThead>
        <SimpleTbody>
          {table.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((value, columnIndex) => (
                <SimpleTd key={columnIndex}>
                  {renderedTable.rows[rowIndex]?.[columnIndex] ?? value}
                </SimpleTd>
              ))}
            </tr>
          ))}
        </SimpleTbody>
      </SimpleTable>
    </SimpleTableWrapper>
  );
}

const SimpleTableWrapper = styled.div`
  overflow-x: auto;
  margin: 1rem 0;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-radius: 0.5rem;
  font-family: Eesti, sans-serif;
`;

const SimpleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 1.4rem;
`;

const SimpleThead = styled.thead`
  background-color: rgba(0, 0, 0, 0.04);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

const SimpleTbody = styled.tbody`
  tr:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
`;

const SimpleTh = styled.th`
  padding: 1.2rem 1.6rem;
  text-align: left;
  font-weight: 600;
  color: #111;
  white-space: nowrap;
  font-size: 1.4rem;
`;

const SimpleTd = styled.td`
  padding: 1.2rem 1.6rem;
  vertical-align: top;
  color: #333;
  line-height: 1.55;
`;
